import { Pipe, PipeTransform } from '@angular/core';
import { translateTerminalConnectionStatus } from '../mappers/enum-translation-mapper';
import { TerminalConnectionStatus } from 'src/app/features/payment-terminal/pts/pts-payment-terminal-model';

@Pipe({
  name: 'translateTerminalConnectionStatusEnum',
})
export class TranslateTerminalConnectionStatusEnumPipe implements PipeTransform {
  transform(value: TerminalConnectionStatus | null | undefined): string {
    if (!value) return '';
    return translateTerminalConnectionStatus(value);
  }
}
